var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Calculator',{attrs:{"type":2,"title":"Sheep","summary":"Calculate the approximated stocking rate of sheep using the fields below","ispecifyAllowance":1,"ibreeds":[
    { name: 'Merino adult wether', allowance: 1.5 },
    { name: 'Crossbred weaner', allowance: 1.5 },
    { name: 'Crossbred ewe', allowance: 2 },
    { name: 'Crossbred ewe with lamb/s', allowance: 2.5 }
  ],"ipaddock":{
    size: 15,
    growthRate: 10,
    pastureStart: 2000,
    pastureEnd: 1200,
    daysGrazing: 10
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }